//获取通知
import {fetchMyPolicyList, fetchPolicyList, getPreCheckPost} from '@/api/insurance/policy'
import {getAwardProgress} from '@/api/insurance/settlement'
import {currentYYYYmmddNotices} from '@/util/date'
import {getInsureTypeName} from '@/util/insureTypesUtils'
import {validatenull} from '@/util/validate'
import {proxyProcessMy} from '@/views/insuranceCenter/api/insureApiNew'
import {isMainChannelAndInner} from './channelUtil'

export function getNoticeContent(noticesContent) {
	//处理时间
	let tempTime = currentYYYYmmddNotices()
	//续保
	onGetXuBaoHint()
		.then(({dateNum = [], isShowHint}) => {
			noticesContent.push({
				contentList: [
					`截止${tempTime}`,
					'，有',
					`${dateNum[0]}red`,
					'条保单将于3日内到期，',
					`${dateNum[1]}red`,
					'条保单将于7日内到期',
				],
				btnContent: '请尽快操作 >>',
				path: isShowHint === 1 ? '/insurance/policy/index' : '/statistics/policy/index',
				query: {status: '2'},
			})
		})
		.catch(() => {})
	//退保填写资料
	onGetTuiBaoHint()
		.then((tuibaoData = []) => {
			if (tuibaoData && tuibaoData.length > 0) {
				tuibaoData = tuibaoData.filter(({applyType, status}) => applyType === 201 && status === 1)
				if (tuibaoData.length > 0) {
					noticesContent.push({
						contentList: [
							`截止${tempTime}`,
							'，有',
							`${tuibaoData.length}red`,
							'件保单需要在当天完成退保的相关材料上传',
						],
						btnContent: '请尽快操作 >>',
						path: '/insurance/policy/index',
						query: {status: '-2'},
					})
				}
			}
		})
		.catch(() => {})
	//对公
	onGetPolicyData(1)
		.then((duiGongData) => {
			if (duiGongData && duiGongData.length > 0) {
				duiGongData = duiGongData.filter(({paySource, certFile = ''}) => paySource === 2 && certFile === '')
				if (duiGongData.length > 0) {
					noticesContent.push({
						contentList: [`截止${tempTime}`, '，有', `${duiGongData.length}red`, '件保单需要完成对公支付'],
						btnContent: '请尽快操作 >>',
						path: '/insurance/policy/index',
						query: {status: '1'},
					})
				}
			}
		})
		.catch(() => {})

	// //续保红包
	// onGetXuBaoRedPacketHint()
	// 	.then((resData = []) => {
	// 		if (resData.length > 0) {
	// 			noticesContent.push({
	// 				contentList: [`截止${tempTime}`, '，有', `${resData.length}red`, '个企业成功续保后可领取小惊喜！'],
	// 				btnContent: '请尽快操作 >>',
	// 				path: '/insurance/policy/index',
	// 				query: {status: '2'},
	// 			})
	// 		}
	// 	})
	// 	.catch(() => {})

	//奖励结算提醒 主渠道或者主渠道内勤才显示
	if (isMainChannelAndInner()) {
		onGetReward()
			.then((resData = []) => {
				if (resData.length > 0) {
					for (let resDatum of resData) {
						noticesContent.push({
							contentList: [resDatum],
							btnContent: '马上投保 >>',
							path: '/insurance/product/list/index',
						})
					}
				}
			})
			.catch(() => {})
	}

	if (isMainChannelAndInner()) {
		//临期（3天）仍有未使用的佣金券对渠道的主账号与内勤账号进行登录弹窗的提醒
		onGetCouponHint()
			.then((tempCouponList = []) => {
				if (tempCouponList.length > 0) {
					noticesContent.push({
						contentList: [`截止${tempTime}`, '，有', `${tempCouponList.length}red`, '个佣金券即将过期'],
						btnContent: '请尽快操作 >>',
						path: '/coupon/front/index',
					})
				}
			})
			.catch(() => {})
	}
}

export async function onGetPolicyData(status, pageSize = 500) {
	return new Promise(async (resolve, reject) => {
		// 获取待生效保单
		let {data: {code = -1, data = {}} = {}} =
			(await fetchMyPolicyList({status, pageSize, fields: 'status,endDate,orderId,paySource,certFile'}).catch(
				() => {},
			)) || {}
		if (code === 0) {
			resolve(data.records || [])
		}
		reject()
	})
}

//本渠道（含内勤、子渠道）当天未处理的退保保单件数。
// 提示语：截止X月X日XX点，有N件保单需要在当天完成退保的相关材料上传，请尽快操作>>
export async function onGetTuiBaoHint() {
	return new Promise(async (resolve, reject) => {
		// 获取待生效保单
		let {data: {code = -1, data = {}} = {}} = await proxyProcessMy({proxyFlag: 'apply_list'}).catch(() => {})
		if (code === 0) {
			resolve(data.records || [])
		}
		reject()
	})
}

//续保领红包功能数据
export async function onGetXuBaoRedPacketHint() {
	return new Promise(async (resolve, reject) => {
		let tempData = (await onGetPolicyData(2)) || []
		if (tempData.length > 0) {
			//存在续保，然后在查是否有红包
			let tempOrderIds = tempData.map(({orderId = ''}) => orderId)
			let checkResult = (await getPreCheckPost({orderIds: tempOrderIds}).catch(() => {})) || {}
			let {code: code1 = -1, data: data1 = []} = checkResult.data || {}
			if (code1 === 0 && data1.length > 0) {
				resolve(data1.filter(({repurchase = false}) => repurchase))
			}
		}
		reject()
	})
}

//续保数据
export function onGetXuBaoHint() {
	return new Promise(async (resolve, reject) => {
		let isShowHint = 0
		let dateNum = []
		// 获取待生效保单
		let {data: {code = -1, data = {}} = {}} =
			(await fetchMyPolicyList({
				status: 2,
				pageSize: 100,
				fields: 'status,endDate',
			}).catch(() => {})) || {}
		if (code === 0) {
			let {records = []} = data
			if (records.length > 0) {
				dateNum = onGetDate(records)
				if (dateNum[0] !== 0 || dateNum[1] !== 0) {
					isShowHint = 1
				}
			}
			if (isShowHint === 0) {
				//再获取数据查询有没有续保
				let {data: {code: codeAll, data: dataAll} = {}} = await fetchPolicyList({
					status: 2,
					pageSize: 100,
					fields: 'status,endDate',
				}).catch(() => {})
				if (codeAll === 0) {
					let {records: recordsAll = []} = dataAll
					dateNum = onGetDate(recordsAll)
					if (dateNum[0] !== 0 || dateNum[1] !== 0) {
						isShowHint = 2
					}
				}
			}
		}
		if (isShowHint !== 0) {
			resolve({dateNum, isShowHint})
		}
		reject()
	})
}

//获取续保日期
function onGetDate(records = []) {
	let threeDateNum = 0
	let sevenDateNum = 0
	let oneDate = 24 * 60 * 60 * 1000
	let currentMill = new Date().getTime()
	for (let {status = -1, endDate = ''} of records) {
		if (status === 3 && endDate !== '') {
			let tempEndDate = new Date(`${endDate} 23:59:59`).getTime()
			if (tempEndDate <= currentMill + 3 * oneDate) {
				threeDateNum++
				sevenDateNum++
			} else if (tempEndDate <= currentMill + 7 * oneDate) {
				sevenDateNum++
			}
		}
	}
	return [threeDateNum, sevenDateNum]
}

//获取奖励提醒
function onGetReward() {
	return new Promise(async (resolve, reject) => {
		try {
			let {data: {code = -1, data = []} = {}} = await getAwardProgress().catch(() => {})
			if (code !== 0 || data.length <= 0) {
				reject()
			}
			let tempHint = []
			for (let {id, name, insureTypes, ruleItems = [], combines = [], progresses = []} of data) {
				let tempData = []
				let tempRules = [{id, name, insureTypes, ruleItems}, ...combines]
				tempRules.forEach((tempRule) => {
					let tempPro = progresses.find(({ruleId}) => ruleId === tempRule.id)
					if (tempPro) {
						tempRule.progress = tempPro
					}
				})
				tempData = tempData.concat(tempRules)
				//获取有多少个达标条件
				// console.log('tempData-------', tempData)
				//根据rate处理数据
				let tempRateList = []
				for (let {ruleItems: ruleItems1 = [], insureTypes: insureTypes1, name: name1, progress = {}} of tempData) {
					for (const ruleItem of ruleItems1) {
						let {moneyThreshold, awardRate} = ruleItem
						//添加
						// tempRateList.push({moneyThreshold, awardRate, insureTypes: insureTypes1, name: name1, progress})
						let index = tempRateList.findIndex((tempRate) => tempRate.moneyThreshold === moneyThreshold)
						if (index === -1) {
							//没有则添加
							tempRateList.push({moneyThreshold, awardRate, insureTypes: insureTypes1, name: name1, progress})
						} else {
							//有则合并
							tempRateList[index].insureTypes = `${tempRateList[index].insureTypes},${insureTypes1}`
							tempRateList[index].progress = progress
						}
					}
				}
				tempRateList = tempRateList.sort((a, b) => a.moneyThreshold - b.moneyThreshold)
				// console.log('tempRateList-------', tempRateList)
				let isAdd = false
				for (let {name: name2, insureTypes: insureTypes2, awardRate, moneyThreshold, progress} of tempRateList) {
					//通过insureTypes，获取名称
					let tempType = insureTypes2.split(',') || []
					let tempTitle = `【${getInsureTypeName(tempType[0])}】`
					let tempResultData = null
					//判断有几个险种不符合
					let tempNum = 0
					if (!validatenull(progress)) {
						for (let tempTypeElement of tempType) {
							let {totalMoney = '', insureTypes: insureTypes3} = progress
							if (insureTypes3.includes(tempTypeElement)) {
								//通过ruleItems，获取满足金额
								if (moneyThreshold * 100 > parseInt(totalMoney) - 1000) {
									if (!tempResultData) {
										tempResultData = {
											moneyThreshold: (moneyThreshold - parseInt(totalMoney) / 100).toFixed(2),
											awardRate,
										}
									}
									tempNum++
								}
							} else {
								if (!tempResultData) {
									tempResultData = {moneyThreshold, awardRate}
								}
								tempNum++
							}
						}
					} else {
						tempResultData = {moneyThreshold, awardRate}
					}
					//么有钱
					if (tempResultData && !isAdd && tempResultData.moneyThreshold < 1000) {
						isAdd = true
						// tempHint.push(`${tempTitle}再投保${tempResultData.moneyThreshold}元，可获得【${name2}】的${awardRate / 100}个点奖励。`)
						tempHint.push(
							`${tempTitle}${tempNum > 1 ? '等' : ''}再投保${
								tempResultData.moneyThreshold
							}元，可获得【${name2}】的奖励。`,
						)
					}
				}
			}
			resolve(tempHint)
		} catch (e) {
			reject(e)
		}
	})
}
